import * as Routes from "./generated/routes";
import { kibelaContext } from "./utils/kibelaContext";

if (!kibelaContext.supportWidgetEnabled) {
  window.zE("webWidget", "hide");
}

if (!kibelaContext.guest) {
  window.zE("webWidget", "prefill", {
    name: {
      value: kibelaContext.account,
      readOnly: true,
    },
    email: {
      value: kibelaContext.email,
      readOnly: true,
    },
  });
}

window.zE("webWidget", "setLocale", document.documentElement.lang);

// https://bitjourney.kibe.la/notes/7581
const path = window.location.pathname;
const label = path.startsWith("/team/settings/outgoing_webhooks")
  ? "WEBHOOK"
  : path == "/groups"
    ? "GROUP"
    : path.startsWith("/folders")
      ? "FOLDER"
      : path.startsWith("/team/members") || path.startsWith("/members")
        ? "MEMBER"
        : path.startsWith("/search")
          ? "SEARCH"
          : path.startsWith("/settings") || path.startsWith("/team")
            ? "SETTING"
            : "HOME";
window.zE("webWidget", "helpCenter:setSuggestions", { labels: [label] });

window.zESettings = {
  webWidget: {
    chat: {
      suppress: !kibelaContext.supportChatEnabled,
    },
    contactForm: {
      suppress: false,
      fields: [{ id: process.env.ZENDESK_TEAM_SUBDOMAIN_FIELD_ID, prefill: { "*": kibelaContext.team } }],
      title: {
        ja: "メッセージを送る",
        "*": "Send a message",
      },
    },
    helpCenter: {
      chatButton: {
        ja: "会話を始める",
        "*": "Start a conversation",
      },
      messageButton: {
        ja: "メッセージを送る",
        "*": "Send a message",
      },
    },
    authenticate: {
      chat: {
        jwtFn: kibelaContext.guest
          ? undefined
          : function (callback) {
              fetch(Routes.zendeskWidgetTokenPath()).then(function (res) {
                res.text().then(function (jwt) {
                  callback(jwt);
                });
              });
            },
      },
    },
  },
};
